import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { observer } from 'mobx-react-lite'
import { Logout } from '@mui/icons-material'
import {
  Button,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Portal,
  Typography,
} from '@mui/material'
import { IconButton, Icons, Loading, Modal } from '@/components'
import mainDictionary from '@/dictionary'
import { menuItems } from '@/modules/layout/constants'
import { useStores } from '@/stores'
import { storage } from '@/utils/storage'
import { menuStyles } from './styles'

type Props = {
  open: boolean
}

export const Menu = observer(({ open }: Props) => {
  const { authStore } = useStores()
  const navigate = useNavigate()
  const location = useLocation()
  const [openModal, setOpenModal] = useState(false)
  const [openPortal, setOpenPortal] = useState(false)

  const handleMenuLinkClick = (path: string) => {
    navigate(path)
  }

  const activeLink = `/${location.pathname?.split('/')[1]}`

  const handleModalClose = () => {
    setOpenModal(false)
  }

  const handleModalOpen = () => {
    setOpenModal(true)
  }

  const logout = async () => {
    const token = storage.get('fcmToken')

    if (token) {
      const info = {
        fcmToken: token,
      }

      await authStore.logOut(info)
    }

    setOpenModal(false)
    setOpenPortal(false)
    storage.clearAll()
    window.location.reload()
  }

  const handleLogoutClick = async () => {
    setOpenPortal(true)

    logout()
  }

  const dialogActions = (
    <>
      <Button onClick={handleModalClose}>{mainDictionary.no}</Button>
      <Button variant="contained" onClick={handleLogoutClick}>
        {mainDictionary.yes}
      </Button>
    </>
  )

  return (
    <List sx={menuStyles.list}>
      <List sx={menuStyles.menuListWrapper}>
        {menuItems?.map((item) => (
          <ListItem
            key={item?.path}
            disablePadding
            sx={{
              ...menuStyles.menuList,
              ...(activeLink === item?.path ? menuStyles.menuActiveList : {}),
            }}
          >
            <ListItemButton
              onClick={handleMenuLinkClick.bind(null, item?.path)}
              sx={{
                ...menuStyles.menuButtons,
                ...(!open ? menuStyles.menuJustify : {}),
              }}
            >
              <ListItemIcon sx={menuStyles.menuJustify}>{item?.icon}</ListItemIcon>

              {open && <ListItemText primary={item?.label} />}
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <List sx={menuStyles.menuListWrapper}>
        <ListItem onClick={handleModalOpen} sx={menuStyles.menuList}>
          <ListItemButton
            sx={{
              ...menuStyles.menuButtons,
              ...(!open ? menuStyles.menuJustify : {}),
              ...menuStyles.gap,
            }}
          >
            <Logout color="error" />

            {open && <ListItemText primary="Chiqish" />}
          </ListItemButton>
        </ListItem>
      </List>

      <Modal open={openModal} onClose={handleModalClose} dialogActions={dialogActions} width={600} fullHeight={false}>
        <Grid container sx={menuStyles.logoutModalBodyWrapper}>
          <Grid>
            <Typography variant="h3" gutterBottom>
              {mainDictionary.logoutModalTitle}
            </Typography>
          </Grid>
          <Grid>
            <IconButton onClick={handleModalClose}>
              <Icons.ClearIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Modal>

      {openPortal && (
        <Portal>
          <Loading />
        </Portal>
      )}
    </List>
  )
})
